
export type ObjectFieldTypes = {
    [key: string]: { [key: string]: string | string[] }
};

export type OpTypes = {
    [key: string]: string | string[]
};

export type ScalarLocations = {
 scalars: string[],
 inputObjectFieldTypes: ObjectFieldTypes;
 outputObjectFieldTypes: ObjectFieldTypes;
 operationMap: OpTypes;
};

export const scalarLocations : ScalarLocations = {
  "inputObjectFieldTypes": {
    "Confirmation24HourCreateInput": {
      "cpContacted": "DateTime"
    },
    "Confirmation24HourUpdateInput": {
      "cpContacted": "DateTime"
    },
    "ContactUpdateInput": {
      "createdDate": "DateTime",
      "inviteSent": "DateTime",
      "modifiedDate": "DateTime",
      "passwordCreated": "DateTime"
    },
    "CounterOfferLogCreateInput": {
      "counterDate1": "DateTime",
      "counterDate2": "DateTime",
      "counterDate3": "DateTime",
      "counterOfferStamp": "DateTime",
      "cpRepDate": "DateTime"
    },
    "CounterOfferLogUpdateInput": {
      "counterDate1": "DateTime",
      "counterDate2": "DateTime",
      "counterDate3": "DateTime",
      "counterOfferStamp": "DateTime",
      "cpRepDate": "DateTime"
    },
    "CourseCloseInput": {
      "paperworkReceived": "DateTime"
    },
    "CourseUpdateInput": {
      "acceptedTime": "DateTime",
      "additionalInstructors": "AdditionalInstructorInput",
      "altCourseDate": "DateTime",
      "arcAcceptedTime": "DateTime",
      "cancelledTime": "DateTime",
      "cardExpirationDate": "DateTime",
      "confCalls": "DateTime",
      "confirmedDate": "DateTime",
      "counterOfferStamp": "DateTime",
      "courseDate": "DateTime",
      "dateAdded": "DateTime",
      "dateAssignedToTs": "DateTime",
      "dateBooksOrdered": "DateTime",
      "dateEntered": "DateTime",
      "dateSent": "DateTime",
      "instructorAcceptedTime": "DateTime",
      "instructorConfirmedDate": "DateTime",
      "issuedDate": "DateTime",
      "modified": "DateTime",
      "paperworkReceived": "DateTime"
    },
    "InstructorAssignmentCreateInput": {
      "acceptedDate": "DateTime",
      "removedDate": "DateTime"
    },
    "InstructorAssignmentUpdateInput": {
      "acceptedDate": "DateTime",
      "assignedDate": "DateTime",
      "removedDate": "DateTime"
    },
    "StudentCreateInput": {
      "markedAbsent": "DateTime"
    },
    "StudentUpdateInput": {
      "markedAbsent": "DateTime"
    },
    "TrainingSiteInvoiceCreateInput": {
      "invoiceDate": "DateTime"
    }
  },
  "outputObjectFieldTypes": {
    "ArcBatch": {
      "created": "DateTime",
      "entries": "ArcBatchEntry",
      "lastRun": "DateTime"
    },
    "ArcBatchEntry": {
      "created": "DateTime",
      "transmittedDate": "DateTime"
    },
    "Contact": {
      "createdDate": "DateTime",
      "inviteSent": "DateTime",
      "modifiedDate": "DateTime",
      "passwordCreated": "DateTime"
    },
    "ContactMappableNearZip": {
      "contacts": "ContactGeo"
    },
    "CounterOfferLog": {
      "counterDate1": "DateTime",
      "counterDate2": "DateTime",
      "counterDate3": "DateTime",
      "counterOfferStamp": "DateTime",
      "cpRepDate": "DateTime"
    },
    "Course": {
      "acceptedTime": "DateTime",
      "additionalInstructors": "AdditionalInstructor",
      "altCourseDate": "DateTime",
      "arcAcceptedTime": "DateTime",
      "cancelledTime": "DateTime",
      "cardExpirationDate": "DateTime",
      "confCalls": "DateTime",
      "confirmedDate": "DateTime",
      "coordinates": "Coordinates",
      "counterOfferStamp": "DateTime",
      "courseDate": "DateTime",
      "dateAdded": "DateTime",
      "dateAssignedToTs": "DateTime",
      "dateBooksOrdered": "DateTime",
      "dateEntered": "DateTime",
      "dateSent": "DateTime",
      "instructorAcceptedTime": "DateTime",
      "instructorConfirmedDate": "DateTime",
      "issuedDate": "DateTime",
      "modified": "DateTime",
      "paperworkReceived": "DateTime",
      "projectPaperworkInstructions": "ProjectPaperworkInstructionsEntity",
      "students": "Student"
    },
    "CourseAndConfirmation": {
      "confirmation24Hour": "PartialConfirmation24HourEntity",
      "course": "Course"
    },
    "CourseContactLocation": {
      "contact": "Contact",
      "course": "Course"
    },
    "InstructorAssignment": {
      "acceptedDate": "DateTime",
      "assignedDate": "DateTime",
      "removedDate": "DateTime"
    },
    "InstructorAssignmentDetails": {
      "assigned": "Contact",
      "course": "Course",
      "instructor": "Contact",
      "instructorAssignment": "InstructorAssignment",
      "removed": "Contact"
    },
    "InstructorCourseEvidence": {
      "uploadedAt": "DateTime"
    },
    "Mutation": {
      "confirmation24HourCreate": "Confirmation24HourCreateResult",
      "counterOfferLogCreate": "CounterOfferLogCreateResult",
      "instructorAssignmentCreate": "InstructorAssignmentCreateResult",
      "instructorCourseEvidenceCreate": "InstructorCourseEvidenceCreateResult",
      "jobNotesPaperworkCreate": "JobNotesPaperworkCreateResult",
      "studentCreate": "StudentCreateResult",
      "trainingSiteInvoiceCreate": "TrainingSiteInvoiceCreateResult"
    },
    "PartialConfirmation24HourEntity": {
      "cpContacted": "DateTime"
    },
    "ProjectPaperworkInstructionsEntity": {
      "dateAdded": "DateTime"
    },
    "Query": {
      "arcSyncBatch": "ArcBatch",
      "arcSyncBatches": "ArcBatch",
      "contact": "Contact",
      "contactByEmail": "Contact",
      "contactsByAccountNameAndRoles": "Contact",
      "contactsInMyAccountByRoles": "Contact",
      "contactsMappableByAccountName": "ContactGeo",
      "contactsMappableInRange": "ContactGeo",
      "contactsMappableNearZipCrossAccount": "ContactMappableNearZip",
      "counterOfferLog": "CounterOfferLog",
      "counterOfferLogForCourse": "CounterOfferLog",
      "course": "Course",
      "courseAllUpcomingOnDate": "CourseAndConfirmation",
      "courseConfirmationsByDateRange": "CourseAndConfirmation",
      "courseDetails": "CourseContactLocation",
      "coursesAvailableForAssignment": "CourseContactLocation",
      "coursesAvailableForInstructorAssignment": "CourseContactLocation",
      "coursesRequestedForAssignment": "CourseContactLocation",
      "coursesToInvoiceByTrainingSite": "Course",
      "coursesTsmSearch": "Course",
      "instructorAssignment": "InstructorAssignment",
      "instructorAssignmentsForCourse": "InstructorAssignmentDetails",
      "instructorAssignmentsForCurrentAccountName": "InstructorAssignmentDetails",
      "instructorAssignmentsForInstructor": "InstructorAssignmentDetails",
      "instructorCourseEvidence": "InstructorCourseEvidence",
      "instructorCourseEvidencesByCourse": "InstructorCourseEvidence",
      "jobNotesPaperwork": "JobNotesPaperwork",
      "jobNotesPaperworkForCourse": "JobNotesPaperwork",
      "marketingTrainingSites": "MarketingTrainingSite",
      "student": "Student",
      "trainingSiteInvoice": "TrainingSiteInvoice",
      "zipCodeDetails": "ZipCodeDetails"
    },
    "Student": {
      "markedAbsent": "DateTime"
    },
    "TrainingSiteInvoice": {
      "approvedDate": "DateTime",
      "dateAdded": "DateTime",
      "invoiceDate": "DateTime"
    }
  },
  "operationMap": {},
  "scalars": [
    "DateTime"
  ]
};
